export class pageContent{
    _id:any;
    screenName:any;
    screenId:any;
    title:any;
    text:any=""
    fileUpload:any

}